import { api } from '@/api/client';
import { saveOrderLedgerColumns } from './api';

const localKey = (id: string) => `v2:ledger-columns:${id}`;
const valid = (value: unknown): value is string[] => Array.isArray(value) && value.length <= 18 && new Set(value).size === value.length && value.every((key) => typeof key === 'string');

export function localLedgerColumns(userId: string): string[] | null {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(localKey(userId)) || 'null');
    return valid(parsed) ? parsed : null;
  } catch { return null; }
}

export async function loadLedgerColumns(userId: string): Promise<string[] | null> {
  const local = localLedgerColumns(userId);
  try {
    const remote = await api.get<{ personal: string[] | null; global: string[] | null }>('/api/v2/orders/ledger-columns');
    if (import.meta.env.VITE_READONLY !== '0' && local) return local;
    return valid(remote.personal) ? remote.personal : valid(remote.global) ? remote.global : null;
  } catch { return local; }
}

export async function saveLedgerColumns(userId: string, keys: string[] | null, scope: 'mine' | 'all') {
  if (keys !== null && !valid(keys)) throw new Error('列设置不正确');
  if (scope === 'all') {
    await saveOrderLedgerColumns(scope, keys);
    return;
  }
  try {
    if (keys) localStorage.setItem(localKey(userId), JSON.stringify(keys));
    else localStorage.removeItem(localKey(userId));
  } catch { /* 本机存储不可用时仍尝试账号同步 */ }
  if (import.meta.env.VITE_READONLY === '0') await saveOrderLedgerColumns(scope, keys);
}
